import Cal from '@calcom/embed-react';
import { Box, CircularProgress } from '@mui/material';

import type { BookingDetails } from '@/components/common/CalendarPopupButton';
import settings from '@/constants/pcp/constants';
import useCalendarBooking from '@/hooks/consultations/useCalcomBooking';
import { splitCalBookingUrl } from '@/utils/pcp-helpers';

type CalBookingProps = {
  url: string | undefined;
  email?: string;

  handleBookingSuccess?: (value?: BookingDetails) => void;
  handleRescheduleSuccess?: (value?: BookingDetails) => void;
  handleCancelSuccess?: (value?: BookingDetails) => void;
};

export default function CalBooking({
  url,
  email,
  handleBookingSuccess,
  handleRescheduleSuccess,
  handleCancelSuccess,
}: CalBookingProps) {
  const [urlOrigin, urlPath] = splitCalBookingUrl(url);

  useCalendarBooking({
    handleBookingSuccess,
    handleRescheduleSuccess,
    handleCancelSuccess,
    theme: 'light',
  });

  if (!url) {
    return (
      <Box height="50svh" width="100%" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Cal
      data-testid="cal-booking-embed"
      data-cal-path={urlPath}
      calOrigin={urlOrigin}
      calLink={urlPath}
      config={email ? { email } : {}}
      embedJsUrl={settings.calendarEmbedJsUrl}
    />
  );
}
